// extracted by mini-css-extract-plugin
export default {"newsfeed":"aL-z"};